const _HOLIDAYS = {
    "2025-01-01": "1er janvier",
    "2025-04-21": "Lundi de Pâques",
    "2025-05-01": "1er mai",
    "2025-05-08": "8 mai",
    "2025-05-29": "Ascension",
    "2025-06-09": "Lundi de Pentecôte",
    "2025-07-14": "14 juillet",
    "2025-08-15": "Assomption",
    "2025-11-01": "Toussaint",
    "2025-11-11": "11 novembre",
    "2025-12-25": "Jour de Noël",
    "2024-01-01": "1er janvier",
    "2024-04-01": "Lundi de Pâques",
    "2024-05-01": "1er mai",
    "2024-05-08": "8 mai",
    "2024-05-09": "Ascension",
    "2024-05-20": "Lundi de Pentecôte",
    "2024-07-14": "14 juillet",
    "2024-08-15": "Assomption",
    "2024-11-01": "Toussaint",
    "2024-11-11": "11 novembre",
    "2024-12-25": "Jour de Noël",
    "2023-01-01": "1er janvier",
    "2023-04-10": "Lundi de Pâques",
    "2023-05-01": "1er mai",
    "2023-05-08": "8 mai",
    "2023-05-18": "Ascension",
    "2023-05-29": "Lundi de Pentecôte",
    "2023-07-14": "14 juillet",
    "2023-08-15": "Assomption",
    "2023-11-01": "Toussaint",
    "2023-11-11": "11 novembre",
    "2023-12-25": "Jour de Noël",
    "2022-01-01": "1er janvier",
    "2022-04-18": "Lundi de Pâques",
    "2022-05-01": "1er mai",
    "2022-05-08": "8 mai",
    "2022-05-26": "Ascension",
    "2022-06-06": "Lundi de Pentecôte",
    "2022-07-14": "14 juillet",
    "2022-08-15": "Assomption",
    "2022-11-01": "Toussaint",
    "2022-11-11": "11 novembre",
    "2022-12-25": "Jour de Noël",
    "2021-01-01": "1er janvier",
    "2021-04-05": "Lundi de Pâques",
    "2021-05-01": "1er mai",
    "2021-05-08": "8 mai",
    "2021-05-13": "Ascension",
    "2021-05-24": "Lundi de Pentecôte",
    "2021-07-14": "14 juillet",
    "2021-08-15": "Assomption",
    "2021-11-01": "Toussaint",
    "2021-11-11": "11 novembre",
    "2021-12-25": "Jour de Noël",
    "2020-01-01": "1er janvier",
    "2020-04-13": "Lundi de Pâques",
    "2020-05-01": "1er mai",
    "2020-05-08": "8 mai",
    "2020-05-21": "Ascension",
    "2020-06-01": "Lundi de Pentecôte",
    "2020-07-14": "14 juillet",
    "2020-08-15": "Assomption",
    "2020-11-01": "Toussaint",
    "2020-11-11": "11 novembre",
    "2020-12-25": "Jour de Noël",
    "2019-01-01": "1er janvier",
    "2019-04-22": "Lundi de Pâques",
    "2019-05-01": "1er mai",
    "2019-05-08": "8 mai",
    "2019-05-30": "Ascension",
    "2019-06-10": "Lundi de Pentecôte",
    "2019-07-14": "14 juillet",
    "2019-08-15": "Assomption",
    "2019-11-01": "Toussaint",
    "2019-11-11": "11 novembre",
    "2019-12-25": "Jour de Noël",
    "2018-01-01": "1er janvier",
    "2018-04-02": "Lundi de Pâques",
    "2018-05-01": "1er mai",
    "2018-05-08": "8 mai",
    "2018-05-10": "Ascension",
    "2018-05-21": "Lundi de Pentecôte",
    "2018-07-14": "14 juillet",
    "2018-08-15": "Assomption",
    "2018-11-01": "Toussaint",
    "2018-11-11": "11 novembre",
    "2018-12-25": "Jour de Noël",
    "2017-01-01": "1er janvier",
    "2017-04-17": "Lundi de Pâques",
    "2017-05-01": "1er mai",
    "2017-05-08": "8 mai",
    "2017-05-25": "Ascension",
    "2017-06-05": "Lundi de Pentecôte",
    "2017-07-14": "14 juillet",
    "2017-08-15": "Assomption",
    "2017-11-01": "Toussaint",
    "2017-11-11": "11 novembre",
    "2017-12-25": "Jour de Noël",
    "2016-01-01": "1er janvier",
    "2016-03-28": "Lundi de Pâques",
    "2016-05-01": "1er mai",
    "2016-05-05": "Ascension",
    "2016-05-08": "8 mai",
    "2016-05-16": "Lundi de Pentecôte",
    "2016-07-14": "14 juillet",
    "2016-08-15": "Assomption",
    "2016-11-01": "Toussaint",
    "2016-11-11": "11 novembre",
    "2016-12-25": "Jour de Noël",
    "2015-01-01": "1er janvier",
    "2015-04-06": "Lundi de Pâques",
    "2015-05-01": "1er mai",
    "2015-05-08": "8 mai",
    "2015-05-14": "Ascension",
    "2015-05-25": "Lundi de Pentecôte",
    "2015-07-14": "14 juillet",
    "2015-08-15": "Assomption",
    "2015-11-01": "Toussaint",
    "2015-11-11": "11 novembre",
    "2015-12-25": "Jour de Noël",
    "2014-01-01": "1er janvier",
    "2014-04-21": "Lundi de Pâques",
    "2014-05-01": "1er mai",
    "2014-05-08": "8 mai",
    "2014-05-29": "Ascension",
    "2014-06-09": "Lundi de Pentecôte",
    "2014-07-14": "14 juillet",
    "2014-08-15": "Assomption",
    "2014-11-01": "Toussaint",
    "2014-11-11": "11 novembre",
    "2014-12-25": "Jour de Noël",
    "2013-01-01": "1er janvier",
    "2013-04-01": "Lundi de Pâques",
    "2013-05-01": "1er mai",
    "2013-05-08": "8 mai",
    "2013-05-09": "Ascension",
    "2013-05-20": "Lundi de Pentecôte",
    "2013-07-14": "14 juillet",
    "2013-08-15": "Assomption",
    "2013-11-01": "Toussaint",
    "2013-11-11": "11 novembre",
    "2013-12-25": "Jour de Noël",
    "2012-01-01": "1er janvier",
    "2012-04-09": "Lundi de Pâques",
    "2012-05-01": "1er mai",
    "2012-05-08": "8 mai",
    "2012-05-17": "Ascension",
    "2012-05-28": "Lundi de Pentecôte",
    "2012-07-14": "14 juillet",
    "2012-08-15": "Assomption",
    "2012-11-01": "Toussaint",
    "2012-11-11": "11 novembre",
    "2012-12-25": "Jour de Noël",
    "2011-01-01": "1er janvier",
    "2011-04-25": "Lundi de Pâques",
    "2011-05-01": "1er mai",
    "2011-05-08": "8 mai",
    "2011-06-02": "Ascension",
    "2011-06-13": "Lundi de Pentecôte",
    "2011-07-14": "14 juillet",
    "2011-08-15": "Assomption",
    "2011-11-01": "Toussaint",
    "2011-11-11": "11 novembre",
    "2011-12-25": "Jour de Noël",
    "2010-01-01": "1er janvier",
    "2010-04-05": "Lundi de Pâques",
    "2010-05-01": "1er mai",
    "2010-05-08": "8 mai",
    "2010-05-13": "Ascension",
    "2010-05-24": "Lundi de Pentecôte",
    "2010-07-14": "14 juillet",
    "2010-08-15": "Assomption",
    "2010-11-01": "Toussaint",
    "2010-11-11": "11 novembre",
    "2010-12-25": "Jour de Noël",
    "2009-01-01": "1er janvier",
    "2009-04-13": "Lundi de Pâques",
    "2009-05-01": "1er mai",
    "2009-05-08": "8 mai",
    "2009-05-21": "Ascension",
    "2009-06-01": "Lundi de Pentecôte",
    "2009-07-14": "14 juillet",
    "2009-08-15": "Assomption",
    "2009-11-01": "Toussaint",
    "2009-11-11": "11 novembre",
    "2009-12-25": "Jour de Noël",
    "2008-01-01": "1er janvier",
    "2008-03-24": "Lundi de Pâques",
    "2008-05-01": "Ascension",
    "2008-05-08": "8 mai",
    "2008-05-12": "Lundi de Pentecôte",
    "2008-07-14": "14 juillet",
    "2008-08-15": "Assomption",
    "2008-11-01": "Toussaint",
    "2008-11-11": "11 novembre",
    "2008-12-25": "Jour de Noël",
    "2007-01-01": "1er janvier",
    "2007-04-09": "Lundi de Pâques",
    "2007-05-01": "1er mai",
    "2007-05-08": "8 mai",
    "2007-05-17": "Ascension",
    "2007-05-28": "Lundi de Pentecôte",
    "2007-07-14": "14 juillet",
    "2007-08-15": "Assomption",
    "2007-11-01": "Toussaint",
    "2007-11-11": "11 novembre",
    "2007-12-25": "Jour de Noël",
    "2006-01-01": "1er janvier",
    "2006-04-17": "Lundi de Pâques",
    "2006-05-01": "1er mai",
    "2006-05-08": "8 mai",
    "2006-05-25": "Ascension",
    "2006-06-05": "Lundi de Pentecôte",
    "2006-07-14": "14 juillet",
    "2006-08-15": "Assomption",
    "2006-11-01": "Toussaint",
    "2006-11-11": "11 novembre",
    "2006-12-25": "Jour de Noël",
    "2005-01-01": "1er janvier",
    "2005-03-28": "Lundi de Pâques",
    "2005-05-01": "1er mai",
    "2005-05-05": "Ascension",
    "2005-05-08": "8 mai",
    "2005-05-16": "Lundi de Pentecôte",
    "2005-07-14": "14 juillet",
    "2005-08-15": "Assomption",
    "2005-11-01": "Toussaint",
    "2005-11-11": "11 novembre",
    "2005-12-25": "Jour de Noël",
    "2004-01-01": "1er janvier",
    "2004-04-12": "Lundi de Pâques",
    "2004-05-01": "1er mai",
    "2004-05-08": "8 mai",
    "2004-05-20": "Ascension",
    "2004-05-31": "Lundi de Pentecôte",
    "2004-07-14": "14 juillet",
    "2004-08-15": "Assomption",
    "2004-11-01": "Toussaint",
    "2004-11-11": "11 novembre",
    "2004-12-25": "Jour de Noël",
    "2003-01-01": "1er janvier",
    "2003-04-21": "Lundi de Pâques",
    "2003-05-01": "1er mai",
    "2003-05-08": "8 mai",
    "2003-05-29": "Ascension",
    "2003-06-09": "Lundi de Pentecôte",
    "2003-07-14": "14 juillet",
    "2003-08-15": "Assomption",
    "2003-11-01": "Toussaint",
    "2003-11-11": "11 novembre",
    "2003-12-25": "Jour de Noël",
    "2002-01-01": "1er janvier",
    "2002-04-01": "Lundi de Pâques",
    "2002-05-01": "1er mai",
    "2002-05-08": "8 mai",
    "2002-05-09": "Ascension",
    "2002-05-20": "Lundi de Pentecôte",
    "2002-07-14": "14 juillet",
    "2002-08-15": "Assomption",
    "2002-11-01": "Toussaint",
    "2002-11-11": "11 novembre",
    "2002-12-25": "Jour de Noël",
    "2001-01-01": "1er janvier",
    "2001-04-16": "Lundi de Pâques",
    "2001-05-01": "1er mai",
    "2001-05-08": "8 mai",
    "2001-05-24": "Ascension",
    "2001-06-04": "Lundi de Pentecôte",
    "2001-07-14": "14 juillet",
    "2001-08-15": "Assomption",
    "2001-11-01": "Toussaint",
    "2001-11-11": "11 novembre",
    "2001-12-25": "Jour de Noël",
    "2000-01-01": "1er janvier",
    "2000-04-24": "Lundi de Pâques",
    "2000-05-01": "1er mai",
    "2000-05-08": "8 mai",
    "2000-06-01": "Ascension",
    "2000-06-12": "Lundi de Pentecôte",
    "2000-07-14": "14 juillet",
    "2000-08-15": "Assomption",
    "2000-11-01": "Toussaint",
    "2000-11-11": "11 novembre",
    "2000-12-25": "Jour de Noël"
}